import { onMounted, onUnmounted, ref } from 'vue';
import type { Ref } from 'vue';

export function useWindowHeight(): { pageHeight: Ref<string> } {
  const pageHeight = ref(window.innerHeight + 'px');

  const updateHeight = (): void => {
    pageHeight.value = window.innerHeight + 'px';
  };

  onMounted(() => {
    window.addEventListener('resize', updateHeight);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateHeight);
  });

  return { pageHeight };
}
